if (!customElements.get('cart-timer')) {
  customElements.define(
    'cart-timer',
    class CartTimer extends HTMLElement {
      static KEY = 'gk_cart_timer_deadline';

      connectedCallback() {
        this.clock = this.querySelector('.cart-timer__clock');
        this.text = this.querySelector('.cart-timer__text');
        const minutes = parseInt(this.dataset.minutes, 10) || 10;
        let deadline = parseInt(sessionStorage.getItem(CartTimer.KEY), 10);
        if (!deadline || Number.isNaN(deadline)) {
          deadline = Date.now() + minutes * 60 * 1000;
          sessionStorage.setItem(CartTimer.KEY, String(deadline));
        }
        this.deadline = deadline;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
        // Reset the timer when the cart becomes empty.
        if (typeof subscribe === 'function' && !this.unsubscribe) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const count = event && event.cartData && event.cartData.item_count;
            if (count === 0) sessionStorage.removeItem(CartTimer.KEY);
          });
        }
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const left = Math.max(0, this.deadline - Date.now());
        const m = Math.floor(left / 60000);
        const s = Math.floor((left % 60000) / 1000);
        this.clock.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        if (left === 0) {
          clearInterval(this.interval);
          this.classList.add('is-expired');
          if (this.dataset.expiredText) {
            this.text.textContent = this.dataset.expiredText;
            this.clock.textContent = '';
          }
        }
      }
    }
  );
}
